import { Alert, ConfigProvider } from "antd";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BannerAlertMessage, { BANNER_ALERT_COMPACT_CLASS } from "./BannerAlertMessage";
import apiClient from "../../helpers/apiClient";
import isBillingEnabled from "../../helpers/billing";
import { useUser } from "../../contexts/UserContext/UserContext";

const SubExpAlert = () => {
    const { t } = useTranslation("banner");
    const [showAlert, setShowAlert] = useState(false);
    const history = useHistory();
    const { state, myCompanyData } = useUser();
    const companyId = myCompanyData?._id;
    const billingEnabled = isBillingEnabled(myCompanyData);

    useEffect(() => {
        // FREE mode: no subscription to check
        if (!state?.isAuthenticated || !companyId || !billingEnabled) {
            setShowAlert(false);
            return undefined;
        }

        let cancelled = false;

        const checkData = async () => {
            try {
                await apiClient.get("/api/company/comp-sub-alert");
                if (!cancelled) {
                    setShowAlert(false);
                }
            } catch (error) {
                if (!cancelled && error.response?.data?.success === false) {
                    setShowAlert(true);
                }
            }
        };

        checkData();

        return () => {
            cancelled = true;
        };
    }, [state?.isAuthenticated, companyId, billingEnabled]);

    const handleCloseAlert = () => {
        setShowAlert(false);
    };

    const handleNavigateToPayment = () => {
        history.push("/settings?menu=billing");
    };

    if (!showAlert) {
        return null;
    }

    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: "#ff5454",
                    colorInfoBg: "#ff5454",
                    colorText: "#000000",
                    colorIcon: "#000000",
                },
                components: {
                    Alert: {
                        // defaultPadding: 0,
                    },
                },
            }}>
            <Alert
                className={BANNER_ALERT_COMPACT_CLASS}
                message={
                    <BannerAlertMessage
                        actionLabel={t("subscriptionAlert.updatePayment", "Update Payment")}
                        onAction={handleNavigateToPayment}>
                        {t("subscriptionAlert.message", "Your subscription has expired or is invalid.")}{" "}
                        <span className="font-semibold">
                            {t("subscriptionAlert.action", "Please update your payment information")}
                        </span>{" "}
                        {t("subscriptionAlert.continuation", "to continue using our services.")}
                    </BannerAlertMessage>
                }
                banner
                type="info"
                closable
                afterClose={handleCloseAlert}
                showIcon={false}
            />
        </ConfigProvider>
    );
};

export default SubExpAlert;
